import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import './ViewMore.scss';
export interface ViewMoreProps {
    linkUrl?: string;
    template: string;
    title: JSX.Element | React.ReactNode | string;
    text: string;
    viewMoreMarkedNoFollow?: boolean;
    enableClientSideLinking?: boolean;
}
export const ViewMore: React.FunctionComponent<ViewMoreProps> = (props) => {
    let component = null;

    if (props.linkUrl) {
        const viewMoreClasses = classNames(
            'view-more-link',
            'eds-link--neutral',
            'eds-text--right',
            'eds-g-cell',
            'eds-g-cell-3-12',
        );
        const anchorText = props.text ? props.text : gettext('View more');

        if (props.enableClientSideLinking) {
            component = (
                <Link
                    className={viewMoreClasses}
                    to={props.linkUrl}
                    aria-label={gettext('View more %(title)s', {
                        title: props.title,
                    }).toString()}
                    rel={props.viewMoreMarkedNoFollow ? 'nofollow' : ''}
                >
                    <span data-testid="view-more-span">{anchorText}</span>
                </Link>
            );
        } else {
            component = (
                <a
                    className={viewMoreClasses}
                    href={props.linkUrl}
                    aria-label={gettext('View more %(title)s', {
                        title: props.title,
                    }).toString()}
                    rel={props.viewMoreMarkedNoFollow ? 'nofollow' : ''}
                >
                    <span data-testid="view-more-span">{anchorText}</span>
                </a>
            );
        }
    }

    return component;
};
